<main class="login-page">
  <section class="login-card">
    <div class="brand-mark">
      <mat-icon>settings_suggest</mat-icon>
    </div>
    <h1>Production Management System</h1>
    <p>Sign in to access your account</p>

    <form (ngSubmit)="submit()">
      <label>
        <span>Email</span>
        <div class="input-shell">
          <mat-icon>mail</mat-icon>
          <input name="email" type="email" [(ngModel)]="email" required maxlength="120" autocomplete="email" />
        </div>
      </label>
      <label>
        <span>Password</span>
        <div class="input-shell">
          <mat-icon>lock</mat-icon>
          <input name="password" [type]="showPassword ? 'text' : 'password'" [(ngModel)]="password" required maxlength="128" autocomplete="current-password" />
          <button class="visibility-toggle" type="button" (click)="showPassword = !showPassword" [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
            <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </div>
      </label>
      <a class="forgot-link" routerLink="/forgot-password">Forgot Password?</a>
      <div class="success" *ngIf="success">{{ success }}</div>
      <div class="error-alert" *ngIf="error">
        <span class="error-icon"><mat-icon>priority_high</mat-icon></span>
        <div>
          <strong>Sign in failed</strong>
          <p>{{ error }}</p>
        </div>
      </div>
      <button class="login-btn" type="submit" [disabled]="loading">{{ loading ? 'Signing in...' : 'Sign In' }}</button>
    </form>
  </section>
</main>
